// @flow
import type { FluxStandardAction } from 'modules/helper';
import type { GalleryImageType } from 'types/common';
import { ProductActionTypes } from './actionTypes';
import type { VersionType } from 'types/product';

export type ProductState = {
  gallery: Array<GalleryImageType> | null,
  versions: Array<VersionType> | null,
  loading: {
    gallery: boolean,
    versions: boolean,
  },
  error: {
    gallery: string | null,
    versions: string | null,
  },
};

const initialState: ProductState = {
  gallery: null,
  versions: null,
  loading: {
    gallery: false,
    versions: false,
  },
  error: {
    gallery: null,
    versions: null,
  },
};

export const ProductReducer = (
  state: ProductState = initialState,
  action: FluxStandardAction
) => {
  const { type, payload, error } = action;

  switch (type) {
    // Gallery
    case ProductActionTypes.GALLERY.FETCH:
      return {
        ...state,
        loading: { ...state.loading, gallery: true },
        error: { ...state.error, gallery: null },
      };
    case ProductActionTypes.GALLERY.SUCCESS:
      return {
        ...state,
        gallery: payload,
        loading: { ...state.loading, gallery: false },
      };
    case ProductActionTypes.GALLERY.FAILURE:
      return {
        ...state,
        loading: { ...state.loading, gallery: false },
        error: { ...state.error, gallery: error },
      };
    // Floor Plan
    case ProductActionTypes.VERSIONS.FETCH:
      return {
        ...state,
        loading: { ...state.loading, versions: true },
        error: { ...state.error, versions: null },
      };
    case ProductActionTypes.VERSIONS.SUCCESS:
      return {
        ...state,
        versions: payload,
        loading: { ...state.loading, versions: false },
      };
    case ProductActionTypes.VERSIONS.FAILURE:
      return {
        ...state,
        loading: { ...state.loading, versions: false },
        error: { ...state.error, versions: error },
      };
    default:
      return state;
  }
};
